import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const fileUrl = (relative) => `${BACKEND_URL}${relative}`;

export function getSessionId() {
  let sid = localStorage.getItem("muse_general_session");
  if (!sid) {
    sid = "sess-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("muse_general_session", sid);
  }
  return sid;
}
